import { useCallback } from 'react';

import { useDispatch } from 'react-redux';

import { deleteFulfillmentPlan } from '../fulfillment-plans.api';
import { bulkloadSalesOrders } from '../../store/bulkload/bulkload.actions';
import { silentRequestGetOrders } from '../../store/orders/orders.actions';
import { unknownError } from './constants';
import { useEntitiesFulfillmentPlanProperty } from '../../hooks/entities/selectors/fulfillment-plans';
import { useEnableReship } from '../../feature-flags/hooks/use-enable-reship';
import {
  DELETE_SHIPMENT_ACTIONS,
  useTrackDeleteShipmentAction,
} from '../../orders/modals/order-details-modal/event-tracking/use-track-order-details-action';

export const useDeleteFulfillmentPlan = ({ fulfillmentPlanId, onSuccess, onError }) => {
  const salesOrdersFulfilledIds = useEntitiesFulfillmentPlanProperty(fulfillmentPlanId, 'salesOrdersFulfilledIds');
  const checkSalesOrderItemsOnly = useEnableReship();
  const dispatch = useDispatch();
  const trackDeleteShipmentSuccess = useTrackDeleteShipmentAction(DELETE_SHIPMENT_ACTIONS.SUCCESS, fulfillmentPlanId);
  const trackDeleteShipmentError = useTrackDeleteShipmentAction(DELETE_SHIPMENT_ACTIONS.ERROR, fulfillmentPlanId);

  return useCallback(async () => {
    try {
      await deleteFulfillmentPlan(fulfillmentPlanId, checkSalesOrderItemsOnly);
      dispatch(bulkloadSalesOrders(salesOrdersFulfilledIds));
      dispatch(silentRequestGetOrders());
      trackDeleteShipmentSuccess();
      onSuccess();
    } catch (err) {
      trackDeleteShipmentError(err);
      const code = err.Errors?.[0]?.Code ?? unknownError;
      onError(code);
    }
  }, [
    dispatch,
    fulfillmentPlanId,
    onSuccess,
    onError,
    salesOrdersFulfilledIds,
    checkSalesOrderItemsOnly,
    trackDeleteShipmentSuccess,
    trackDeleteShipmentError,
  ]);
};
